/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import LinkButton from 'flarum/common/components/LinkButton';
import listItems from 'flarum/common/helpers/listItems';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import { slug } from '../../../common';
import LeaderboardListItem from './LeaderboardListItem';
import SelfRankCard from './SelfRankCard';

const DEFAULT_ACTIVITY = 'exp';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.forum.leaderboard.nav`;

export default class LeaderboardSidebar extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		return <ul className="LeaderboardSidebar">{listItems(this.items().toArray())}</ul>;
	}

	/**
	 * @return {ItemList}
	 */
	items() {
		const items = new ItemList();

		const hideSelfCard = app.forum.attribute(`${slug}.leaderboard.hide_self_card`) || false;

		if (app.session.user && !hideSelfCard) {
			items.add('self-rank', <SelfRankCard />, 100);
		}

		items.add(
			'nav',
			<SelectDropdown buttonClassName="Button" className="App-titleControl">
				{this.navItems().toArray()}
			</SelectDropdown>,
			90
		);

		return items;
	}

	/**
	 * @return {ItemList}
	 */
	navItems() {
		const items = new ItemList();

		app.leaderboard?.activities?.forEach((activity) => {
			let _route = 'activityLeaderboard';
			let params = app.leaderboard.stickyParams();

			if (activity.id() === DEFAULT_ACTIVITY) {
				_route = 'leaderboard';
			} else {
				params = {
					...params,
					activityType: activity.id(),
				};
			}

			const active = activity.id() === app.leaderboard?.activityType;

			items.add(
				activity.id(),
				<LinkButton href={app.route(_route, params)} active={active} icon={LeaderboardListItem.getIconMap()[activity.id()]}>
					{t(`${prfx}.${activity.id()}`)}
				</LinkButton>
			);
		});

		return items;
	}
}
